export default __webpack_public_path__ + "static/media/340.a9dd14f2.jpg";